import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    parcelDetail: null,
};

const parcelDetailSlice = createSlice({
    name: 'parcelDetail',
    initialState,
    reducers: {
        setParcelDetail: (state, { payload }) => {
            const newParcelDetailState = { ...state.parcelDetail, ...payload };
            state.parcelDetail = newParcelDetailState;
        },
        clearParcelDetail: (state) => {
            state.parcelDetail = initialState.parcelDetail;
        },
    },
});

export const { setParcelDetail, clearParcelDetail } = parcelDetailSlice.actions;
export const parcelDetailSelector = (state) => state.parcelDetail;
export default parcelDetailSlice.reducer;
